/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Text from './Text';

import styles from '../../../styles/blocks/fnc.module.scss';

const propTypes = {
    texts: PropTypes.arrayOf(
        PropTypes.shape({
            body: PropTypes.string,
            title: PropTypes.string,
            letter: PropTypes.string.isRequired,
        }),
    ),
    isContainer: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    texts: null,
    isContainer: false,
    className: null,
    containerClassName: null,
};

const FncBlock = ({ texts, isContainer, className, containerClassName }) => (
    <div
        className={classNames({
            [styles.container]: true,
            [className]: className !== null,
        })}
    >
        <div
            className={classNames([
                'blockFnc',
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            {(texts || []).map(({ body, title, letter }, textIndex) => (
                <div className={styles.group} key={`text-${textIndex + 1}`}>
                    <div className={styles.textLetterContainer}>
                        <div className={styles.letterContainer}>{letter}</div>
                        <div className={styles.textLetter}>
                            {title !== null ? <h3 className={styles.title}>{title}</h3> : null}
                            <Text body={body} className={styles.text} />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

FncBlock.propTypes = propTypes;
FncBlock.defaultProps = defaultProps;

export default FncBlock;
